<template>
  <div>
    <h1 class="mb-3">Config Manager (Classic View)</h1>
    
    <!-- Navigation button to new home page -->
    <div class="mb-4">
      <router-link :to="{ name: 'Home' }" class="btn-new-home">
        Go to New Design
      </router-link>
    </div>
    
    <!-- Toggle Switch -->
    <div class="toggle-container mb-4">
      <div class="status-toggle">
        <p v-for="(value, key) in apps" :key="key"><router-link :to="{name: 'Parameters', params:{aid: key}}">{{ value }}</router-link></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    apps() {
      return this.$store.getters.apps
    }
    
  }
}
</script>

<style scoped>
  p {
    font-size: 18px;
  }
</style>